//
//  SDKRichTextSpanAttributeType.ts
//  Supernova SDK
//
//  Created by Jiri Trecak.
//
// --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- ---
// MARK: - Source type enum
export var RichTextSpanAttributeType;
(function (RichTextSpanAttributeType) {
    RichTextSpanAttributeType["bold"] = "Bold";
    RichTextSpanAttributeType["italic"] = "Italic";
    RichTextSpanAttributeType["link"] = "Link";
    RichTextSpanAttributeType["strikethrough"] = "Strikethrough";
    RichTextSpanAttributeType["code"] = "Code";
})(RichTextSpanAttributeType || (RichTextSpanAttributeType = {}));
